"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArrayOpcodeTemplates = getArrayOpcodeTemplates;
function getArrayOpcodeTemplates() {
    return `
                        // Array Operations
                        case opMap[90]: { // NEW_ARRAY
                            stack.push([]);
                            pc++;
                            break;
                        }

                        case opMap[91]: { // ARRAY_PUSH
                            let value = stack.pop();
                            let array = stack[stack.length - 1]; // Peek at array (don't pop)
                            array.push(value);
                            pc++;
                            break;
                        }

                        case opMap[93]: { // SPREAD
                            // Spread operator: marks an array/iterable to be spread in function call
                            // Stack before: [iterable]
                            // Stack after: [{ __spread__: true, value: iterable }]
                            // The CALL/CALL_METHOD opcodes will detect this marker and spread the array
                            let iterable = stack.pop();
                            stack.push({ __spread__: true, value: iterable });
                            pc++;
                            break;
                        }

                        case opMap[94]: { // ARRAY_SPREAD_PUSH
                            // Array spread: pushes all elements from iterable into array
                            // Stack before: [array, iterable]
                            // Stack after: [array] (with elements from iterable pushed)
                            let spreadIterable = stack.pop();
                            let targetArray = stack[stack.length - 1]; // Peek at array (don't pop)
                            // Use Array.prototype.push.apply for efficiency
                            if (Array.isArray(spreadIterable)) {
                                Array.prototype.push.apply(targetArray, spreadIterable);
                            } else {
                                // Handle other iterables (strings, sets, etc.)
                                for (let spreadItem of spreadIterable) {
                                    targetArray.push(spreadItem);
                                }
                            }
                            pc++;
                            break;
                        }

                        // Type Operations
                        case opMap[110]: { // TYPEOF
                            stack.push(typeof stack.pop());
                            pc++;
                            break;
                        }

                        case opMap[111]: { // INSTANCEOF
                            let ctor = stack.pop();
                            let obj = stack.pop();
                            stack.push(obj instanceof ctor);
                            pc++;
                            break;
                        }

                        case opMap[112]: { // TYPEOF_GLOBAL
                            // typeof on global variable - doesn't throw for undeclared
                            let globalName112 = constants[arg];
                            let globalObj112 = (typeof globalThis !== 'undefined' ? globalThis : (typeof window !== 'undefined' ? window : global));
                            stack.push(typeof globalObj112[globalName112]);
                            pc++;
                            break;
                        }
    `;
}
